import React, { FunctionComponent } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader } from 'rs-emd-ui-atoms';
import { useBasketPageQuery } from '../../generated/graphql';
import { PrintAsQuote } from '../../rs-emd-ui-modules/src/components/basket-purchase/basket';
import { RedirectWithStatus } from '../../rs-emd-ui-modules/src/helpers/redirect-with-status.component';
import { IContextInfo, Locale } from '../../rs-emd-ui-modules/src/models/master/context-info.model';
import { productService } from '../../services/product-service';

type PrintAsQuoteProps = {
  contextInfo: IContextInfo;
};

export const PrintAsQuoteWrapper: FunctionComponent<PrintAsQuoteProps> = (props: PrintAsQuoteProps) => {
  let location = useLocation();
  const isDownloadPdf = Boolean(JSON.parse(new URLSearchParams(location.search).get('download') ?? '0'));

  const { loading, error, data } = useBasketPageQuery({
    variables: { asQuote: true },
    ssr: true,
  });

  if (loading) {
    return <Loader />;
  } else if (error || !data) {
    return <RedirectWithStatus to={process.env.REACT_APP_ERROR_ENDPOINT} statusCode={500} />;
  } else if (!data.basketPage.labels || data.basketPage.labels.length === 0) {
    return <RedirectWithStatus to={process.env.REACT_APP_ERROR_404_ENDPOINT} statusCode={404} />;
  } else if (data.basketPage.numberOfItems === 0) {
    return <Navigate to='/cart' />;
  }

  return (
    <PrintAsQuote
      data={data.basketPage}
      showQuoteDetails={!isDownloadPdf}
      isExport={props.contextInfo.locale === Locale.Export}
      productService={productService}
    />
  );
};

export default PrintAsQuoteWrapper;
